import { Link } from "react-router-dom";
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
import Auth from "./routes/Auth";
import Main from "./routes/Main";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import Dashboard from "./routes/Main/pages/Dashboard";

import './styles/styles.css';

import { Fragment, useEffect, useState } from 'react'
import { Disclosure, Menu, Transition } from '@headlessui/react'
import { Bars3Icon, BellIcon, XMarkIcon } from '@heroicons/react/24/outline'

const user = {
  name: 'Customer',
  email: 'noemail@regionsfs.com',
  imageUrl:
    '/assets/images/user-128.png',
}
const navigationGuest = [
  { name: 'Register', href: '/auth/register', current: false },
  { name: 'Log In', href: '/auth/login', current: false },
];

const navigationAuthUser = [
  { name: 'Dashboard', href: '/app/dashboard', current: false },
  { name: 'Loans', href: '/app/loans', current: false },
  { name: 'Connect', href: '/app/connect', current: false },
  { name: 'Verification', href: '/app/verification', current: false },
  { name: 'Profile', href: '/app/profile', current: false },
  { name: 'Reward Points', href: '/app/points', current: true },
];

const userNavigationAuthUser = [
  { name: 'Your Profile', href: '/app/profile' },
  { name: 'Log Out', href: '/auth/logout' },
];

const userNavigationGuest = [
  { name: 'Register', href: '/auth/register' },
  { name: 'Log In', href: '/auth/login' },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

let logoImage = ``;

if ( true ) {
    logoImage = `data:image/png;base64,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`;
};

export default function App() {

  const [navigation, setNavigation] = useState('');

  useEffect( () => {
    window.setConfig();
    if ( !localStorage.HOST_CONFIG ) {
      if ( window.location.href.indexOf('firstRun') >= 0 ) {
        setConfigError(true);
      } else {
        setTimeout(() => window.location.assign('/?firstRun=true'), 1000);
      }
    }
    if ( localStorage.getItem('access_token') && localStorage.getItem('access_token') !== 'invalid_client' ) {
      setNavigation('AUTHED');
    }
  }, []);

  const [configError, setConfigError] = useState(false);
  const [seenSurvey, setSeenSurvey] = useState(localStorage.getItem('answeredSurvey') === 'yes');

  const setAnsweredSurvey = () => {
    localStorage.setItem('answeredSurvey', 'yes');
    setSeenSurvey(true);
  }

  return (
    <>
    {configError && <>
      <h1>Error</h1>
      <p>We encountered an error while attempting to load the app. Please <a href="/?firstRun=true"><strong>try again</strong></a>. If this continues to happen, please contact us.</p>
    </>
    }
    {!configError &&
      <div className="min-h-full text-poppins">
        {/*!seenSurvey && localStorage.getItem('answeredSurvey') !== 'yes' && navigation === 'AUTHED' && <div className={'bg-orange-rfs text-white p-3 text-center'}>
          Will you take a minute to tell us how you feel about this portal? &nbsp;&nbsp; <a className={"clickable text-green-900"} href={"https://mnwx45lsweb.typeform.com/to/VqwNIiOU"} target={"_blank"} onClick={() => setAnsweredSurvey()}>Yes</a> &nbsp; &nbsp; <span className={"clickable text-black"} onClick={() => setAnsweredSurvey()}>No</span>
    </div>*/}
          <Disclosure as="nav" className="bg-rfs-green-009933">
            {({ open }) => (
              <>
                <div className="mx-auto max-w-7xl">
                  <div className="flex-shrink-0 py-5 bg-gray-200 pl-4 md:px-20">
                        <a href={'/'}><img
                          className="logo"
                          src={'/assets/images/my-rfs-logo-regions.png'}
                          alt="MyRFS"
                        /></a>
                      </div>
                  <div className="flex h-16 items-center justify-between md:ml-8 md:mr-10">
                    <div className="flex items-center">
                      <div className="hidden md:block">
                        <div className="ml-10 flex items-baseline space-x-4">
                          {(navigation === 'AUTHED' ? navigationAuthUser : navigationGuest).map((item) => (
                            <a
                              key={item.name}
                              href={item.href}
                              className={classNames(
                                item.current
                                  ? 'bg-rfs-green-009933 text-white'
                                  : 'text-white hover:bg-rfs-green-009933 hover:bg-opacity-75',
                                'px-3 py-2 rounded-md text-sm font-medium'
                              )}
                              aria-current={item.current ? 'page' : undefined}
                            >
                              {item.name}
                            </a>
                          ))}
                        </div>
                      </div>
                    </div>
                    <div className="hidden md:block">
                      <div className="ml-4 flex items-center md:ml-20">
                        {/* Profile dropdown */}
                        <Menu as="div" className="relative ml-3">
                          <div>
                            <Menu.Button className="flex max-w-xs items-center rounded-full">
                              <span className="sr-only">Open user menu</span>
                              <img className="h-20 w-20 mt-4 rounded-full" src={'/assets/images/profile-icon.png'} alt="" />
                            </Menu.Button>
                          </div>
                          <Transition
                            as={Fragment}
                            enter="transition ease-out duration-100"
                            enterFrom="transform opacity-0 scale-95"
                            enterTo="transform opacity-100 scale-100"
                            leave="transition ease-in duration-75"
                            leaveFrom="transform opacity-100 scale-100"
                            leaveTo="transform opacity-0 scale-95"
                          >
                            <Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg">
                              {(navigation === 'AUTHED' ? userNavigationAuthUser : userNavigationGuest).map((item) => (
                                <Menu.Item key={item.name}>
                                  {({ active }) => (
                                    <a
                                      href={item.href}
                                      className={classNames(
                                        active ? 'bg-gray-100' : '',
                                        'block px-4 py-2 text-sm text-gray-700'
                                      )}
                                    >
                                      {item.name}
                                    </a>
                                  )}
                                </Menu.Item>
                              ))}
                            </Menu.Items>
                          </Transition>
                        </Menu>
                      </div>
                    </div>
                    <div className="-mr-2 flex md:hidden">
                      {/* Mobile menu button */}
                      <Disclosure.Button className="inline-flex items-center justify-center rounded-md bg-rfs-green-009933 p-2 text-white hover:bg-opacity-75 hover:text-white ">
                        <span className="sr-only">Open main menu</span>
                        {open ? (
                          <XMarkIcon className="block h-6 w-6" aria-hidden="true" />
                        ) : (
                          <Bars3Icon className="block h-6 w-6" aria-hidden="true" />
                        )}
                      </Disclosure.Button>
                    </div>
                  </div>
                </div>

                <Disclosure.Panel className="md:hidden">
                  <div className="space-y-1 px-2 pt-2 pb-3 sm:px-3">
                    {(navigation === 'AUTHED' ? navigationAuthUser : navigationGuest).map((item) => (
                      <Disclosure.Button
                        key={item.name}
                        as="a"
                        href={item.href}
                        className={classNames(
                          item.current
                            ? 'bg-rfs-green-009933 text-white'
                            : 'text-white hover:bg-rfs-green-009933 hover:bg-opacity-75',
                          'block px-3 py-2 rounded-md text-base font-medium'
                        )}
                        aria-current={item.current ? 'page' : undefined}
                      >
                        {item.name}
                      </Disclosure.Button>
                    ))}
                  </div>
                  {navigation === 'AUTHED' &&
                  <div className="border-t border-rfs-green-009933 pt-4 pb-3">
                    <div className="flex items-center px-5">
                      <div className="flex-shrink-0">
                        <img className="h-10 w-10 rounded-full" src={user.imageUrl} alt="" />
                      </div>
                      <div className="ml-3">
                        <div className="text-base font-medium text-white">{user.name}</div>
                        <div className="text-sm font-medium text-white">{user.email}</div>
                      </div>
                      <button
                        type="button"
                        className="ml-auto flex-shrink-0 rounded-full bg-rfs-green-009933 p-1 text-white hover:text-white"
                      >
                        <span className="sr-only">View notifications</span>
                        <BellIcon className="h-6 w-6" aria-hidden="true" />
                      </button>
                    </div>
                    <div className="mt-3 space-y-1 px-2">
                      {(navigation === 'AUTHED' ? userNavigationAuthUser : userNavigationGuest).map((item) => (
                        <Disclosure.Button
                          key={item.name}
                          as="a"
                          href={item.href}
                          className="block rounded-md px-3 py-2 text-base font-medium text-white hover:bg-rfs-green-009933 hover:bg-opacity-75"
                        >
                          {item.name}
                        </Disclosure.Button>
                      ))}
                    </div>
                  </div>
                  }
                </Disclosure.Panel>
              </>
            )}
          </Disclosure>

          <BrowserRouter>
              <Routes>
                <Route path="auth/*" element={<Auth />} />
                <Route path="app/*" element={<Main />} />
                <Route path="*" element={<Main />} />
              </Routes>
          </BrowserRouter>
          <Footer />
      </div>
    }
    </>
  );
}